import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';

import { SiteCurveState, SiteCurveStore } from './site-curve.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'rank_order',
  sortByOrder: Order.ASC,
})
export class SiteCurveQuery extends QueryEntity<SiteCurveState> {
  siteCurves = toSignal(this.selectAll(), {
    requireSync: true,
  });

  protected store: SiteCurveStore;

  constructor() {
    const store = inject(SiteCurveStore);

    super(store);

    this.store = store;
  }
}
